// Fixed, dated exchange rates used to express country tax thresholds in US dollars.
// Static by design: the Explore page gives estimates, not live conversions.

export const EXPLORER_CURRENCY = 'USD' as const;
export const FX_RATES_AS_OF = '2026-10';

/** Units of USD per 1 unit of the currency. */
export const USD_PER_UNIT: Record<string, number> = {
  USD: 1,
  EUR: 1.08,
  GBP: 1.27,
  AED: 0.2723,
  THB: 0.028,
  SGD: 0.74,
  HKD: 0.128,
  MYR: 0.22,
  BRL: 0.18,
};

/** Currency each country's tax rules are written in (ISO alpha-2 → ISO 4217). */
export const COUNTRY_TAX_CURRENCY: Record<string, string> = {
  AE: 'AED', PT: 'EUR', ES: 'EUR', GB: 'GBP', US: 'USD', TH: 'THB', SG: 'SGD',
  HK: 'HKD', MY: 'MYR', CY: 'EUR', MT: 'EUR', AD: 'EUR', MC: 'EUR', EE: 'EUR', BR: 'BRL',
};

export function toUsd(amount: number, currency: string): number {
  if (!Number.isFinite(amount)) return amount;
  const rate = USD_PER_UNIT[currency];
  if (rate === undefined) throw new Error(`Missing FX rate for ${currency}`);
  return Math.round(amount * rate);
}
